import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorPopupComponent } from '@bp2s/core/errors/error-popup/error-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ErrorPopupComponent],
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
})
export class ErrorPopupModule {}

